/**
 * 部署前缀归一。
 *
 * 外层网关会把子路径部署的根绝对路径再前置一段（见 `basePath.ts` 的说明），
 * 于是会出现 `/hilstabilityserver/simulation-platform/hilstabilityserver/simulation-platform/overview`
 * 这种双前缀 URL。它仍能取到 index.html（静态回落到 index.html），但 react-router 只按
 * basename 剥掉**一层**前缀，剩下的路径没有对应路由 → 整页
 * `Unexpected Application Error! 404 Not Found`。启动时先把重复前缀收敛成一层。
 */

/** 把连续的重复前缀收敛为一层；`base` 为空或路径本就正常时原样返回。 */
export function singleRoutePrefix(pathname: string, base: string): string {
  if (!base) return pathname;
  const duplicated = base + base;
  let value = pathname;
  while (value.startsWith(duplicated)) {
    value = value.slice(base.length);
  }
  return value;
}